import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_AI_GUIDANCE_FACT_CHECK = defineFcm('petition_ai_guidance_fact_check')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				sample_rate: {
					type: 'number',
					normalizer: (v: number) => {
						if (v < 0 || v > 100) {
							throw new Error('Sample rate must be between 0 and 100');
						}
						return v;
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		sample_rate: 20,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'petition-service',
		context: 'AI Guidance Fact Check',
		description: `Gates the fact-check eval workflow for AI-generated petition guidance plans in petition_service, behind a sampled rollout (each fact-check run does a real web search, so it has real cost).

		"enabled" - kill switch for the fact-check workflow.
		"sample_rate" - percentage (0-100) of completed guidance plans that get fact-checked.`,
		template: {
			enabled: true,
			sample_rate: 20,
		},
	});
